<template>
  <div class="miniprogindicator"><div class="bg" :style="bgStyle()"></div><div class="fg" :style="fgStyle()"></div></div>
</template>


<script>
export default {
  props: ['pct','bgcolor','color'],
  computed:{
    getBgColor(){
      if( this._props.bgcolor ) return this._props.bgcolor
      return 'rgba(0,0,0,.15)'
    },
    getColor(){
      if( this._props.color ) return this._props.color
      return 'rgba(0,0,0,1)'
    },
  },
  methods:{
    bgStyle(){
      return {
        'background-color': this.getBgColor,
      }
    },
    fgStyle(){
      return {
        width: this.pct + '%',
        'background-color': this.getColor,
      }
    },
  },
}
</script>

<style lang="scss">
	@import '../styling/global_vars';

  .miniprogindicator {
	    //background-color: rgba(0,0,0,0.18);
	    width: 1.5em;
	    height: 0.3em;
	    position: relative;
	    display: inline-block;
	    top: -0.12em;
	    left: -0.15em;
    .bg {
			position: absolute;
			left:0;
			top:0;
			height: 100%;
			width: 100%;
		}
    .fg {
			background-color: #373737;
			position: absolute;
			left:0;
			top:0;
			height: 100%;
			width:2px;
      transition: all 1500ms $easeOutCubic;
		}

		&.inline { display:inline; }

	}

</style>



// WEBPACK FOOTER //
// Minipctbar.vue?389e158d